<template>
  <div :class="[additionalClasses, 'collect-seedpoints-form']">
    <form class="no-validate">
      <div class="container">
        <div class="form-component__container form-component__container--row">
          <div class="form-component">

            <div class="row mb-3">
              <div class="col-12 col-m-8 col-l-6  col-xl-5 mb-s-3 mb-m-0">
                <file-input @change="updateDocument" :show-errors="showErrors"></file-input>
              </div>
            </div>

            <div class="row">
              <div class="col-12" v-html="translate('lblDescription')"></div>
            </div>

            <invoice
              :groups="invoice"
              :cultures="cultures"
              :api-url="pimMiddlewareApiUrl"
              :tenant="tenant"
              :language="language"
              :show-errors="showErrors"
              @change="updateInvoice"
            ></invoice>

          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div v-if="apiError" class="col-12 error-box mb-3" v-text="translate('lblUnknownError')"></div>
          <div class="button-row col-12 d-flex flex-s-column flex-m-row justify-content-end px-0 mb-5">
            <button
              type="button"
              :class="['flex-last mb-3 mb-m-0 button button--medium button--primary', showErrors && hasErrors ? 'disabled grey' : null]"
              v-text="translate('btnSubmit')"
              @click="submitForm"
            ></button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import FileInput from './components/FileInput.vue';
import Invoice from './components/Invoice.vue';

export default {
  name: 'CollectSeedpointsForm',
  data: () => ({
    formData: null,
    document: null,
    showErrors: false,
    errors: {
      fileInput: true,
      invoice: false,
    },
    apiError: false,
  }),
  props: {
    pimMiddlewareApiUrl: String,
    loyaltyApiUrl: String,
    redirectUrl: String,
    tenant: String,
    language: String,
    additionalClasses: String,
    translations: Object,
    cultures: Array,
    invoice: Array,
  },
  computed: {
    hasErrors() {
      return this.errors.fileInput || this.errors.invoice;
    },
  },
  components: {
    FileInput,
    Invoice,
  },
  methods: {
    updateDocument(document) {
      this.errors.fileInput = !document;
      this.document = document;
    },
    updateInvoice(invoice) {
      this.formData = [];
      this.errors.invoice = true;
      if (invoice) {
        invoice.forEach((group) => {
          if (group.culture && group.culture.key && group.positions && group.positions.length) {
            this.errors.invoice = group.positions.some(
              (position) => Object.values(position.errors)
                .some((error) => error),
            );

            const culture = group.culture.key;
            group.positions.forEach((position) => {
              if (position.variety && position.variety.name && position.quantity) {
                this.formData.push({
                  type: culture,
                  variety: position.variety.name,
                  quantity: parseInt(position.quantity, 10),
                });
              }
            });
          }
        });
      }
    },
    getCookieValue(name) {
      const value = document.cookie.match(`(^|;)\\s*${name}\\s*=\\s*([^;]+)`);
      return value ? value.pop() : '';
    },
    checkValidityState() {
      this.showErrors = true;
      return !this.hasErrors;
    },
    async submitForm() {
      if (!this.checkValidityState()) {
        return;
      }

      const formData = new FormData();
      if (this.document) {
        formData.append('document', this.document);
      }

      formData.append('crops', new Blob([JSON.stringify(this.formData)], {
        type: 'application/json',
      }));

      this.apiError = false;
      await this.$http({
        method: 'post',
        url: this.loyaltyApiUrl,
        headers: {
          Authorization: `Bearer ${this.getCookieValue('Authorization')}`,
          'Content-Type': 'multipart/form-data',
        },
        data: formData,
      }).then(() => {
        if (this.redirectUrl) {
          window.location.href = this.redirectUrl;
        }
      })
        .catch(() => {
          this.apiError = true;
        });
    },
  },
  created() {
    if (this.translations) {
      this.addDictionary(this.translations);
    }
    this.updateInvoice(this.invoice);
  },
};
</script>

<style lang="scss">
.collect-seedpoints-form {
  .form-component {
    background-color: $color-kws-light-gray-50;
  }
}
</style>
